import CloseIcon from "@mui/icons-material/Close";
import { CardActions, Dialog, DialogProps, Slide, SlideProps } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { makeStyles } from "@mui/styles";
import PropTypes from "prop-types";
import React from "react";

const useCloseButtonStyles = makeStyles({
  root: {
    position: "absolute",
    top: 8,
    right: 8,
  },
});

const useDialogStyles = makeStyles({
  root: {},
});

const DialogTransition = React.forwardRef((props: SlideProps, ref) => <Slide direction="up" ref={ref} {...props} />);

export const BaseDialog = ({
  children,
  cancel,
  showFloatingCloseButton = false,
  maxWidth = "sm",
  ...props
}: DialogProps & {
  cancel: () => void;
  showFloatingCloseButton?: boolean;
}) => {
  const closeStyles = useCloseButtonStyles();

  return (
    <Dialog
      fullWidth
      maxWidth={maxWidth}
      transitionDuration={300}
      TransitionComponent={DialogTransition}
      sx={{
        "& .MuiModal-backdrop": {
          background: "linear-gradient(-45deg, #ee7752,rgb(220, 60, 231), #23a6d5, #23d5ab)",
          backgroundSize: "400% 400%",
          filter: "opacity(60%) saturate(40%)",
          animation: "gradient 10s ease infinite",
          "@keyframes gradient": {
            "0%": {
              backgroundPosition: "0% 50%",
            },
            "50%": {
              backgroundPosition: "50% 100%",
            },
            "100%": {
              backgroundPosition: "0% 50%",
            },
          },
        },
        "& .MuiDialog-paper": {
          borderRadius: 4,
          backgroundClip: "padding-box",
          boxSizing: "border-box",
          filter: "opacity(1)",
          border: 5,
          borderColor: "transparent",
          px: 2,
          py: 1,
        },
      }}
      {...props}
    >
      {showFloatingCloseButton && (
        <CardActions classes={closeStyles}>
          <IconButton sx={{ zIndex: 1, color: "#FFF" }} onClick={cancel} aria-label="cancel">
            <CloseIcon />
          </IconButton>
        </CardActions>
      )}
      {children}
    </Dialog>
  );
};

BaseDialog.propTypes = {
  children: PropTypes.any.isRequired,
  cancel: PropTypes.func.isRequired,
  showFloatingCloseButton: PropTypes.bool,
  maxWidth: PropTypes.oneOf(["xs", "sm", "md", "lg", "xl"]),
};
